import { booleanClockwise, rewind } from '3rd-party-wrappers/turf';

/* The GeoJSON standard ( https://tools.ietf.org/html/rfc7946#section-3.1.6 )is right-hand winding, and it would make
  sense to me to make that the standard. Except:

  - Services are returning geometry with left-hand winding. Saving back zones in a right-hand winding may cause
    issues.
  - D3 insists on left-hand winding.

  For now, I'm calling the left-hand winding standard. If a 3rd-party library has problems with left-hand, can
  special-case around it or do something else when that comes up. I will also leave in the unused code and tests
  for right-hand winding in anticipation that it may be needed.
 */
const STANDARD_IS_RIGHT_HAND = false;

/** @return Fixed ring coordinates if fix was needed. Otherwise, null. */
export const calculatePolygonRingWindingFix = (ringCoordinates, ringIndex, isRightHand = STANDARD_IS_RIGHT_HAND) => {
  const line = { type:'LineString', coordinates:ringCoordinates };
  const isExteriorRing = (ringIndex === 0);
  const shouldRingBeClockwise = isExteriorRing ? !isRightHand : isRightHand;
  if (booleanClockwise(line) === shouldRingBeClockwise) { return null; }
  const reversedLine = rewind(line, {reverse:!shouldRingBeClockwise});
  return reversedLine.coordinates;
};

/** @return Fixed polygon if fix was needed. Otherwise, original instance of polygon, unchanged. */
const _getPolygonWinding = (polygon, isRightHand) => {
  const rings = [...polygon.coordinates];
  let didRingsChange = false;
  rings.forEach((line, index) => {
    const fixedRingCoordinates = calculatePolygonRingWindingFix(rings[index], index, isRightHand);
    if (fixedRingCoordinates) {
      rings[index] = fixedRingCoordinates;
      didRingsChange = true;
    }
  });
  return didRingsChange ? { type:'Polygon', coordinates:[...rings] } : polygon;
};

/* Calling code should be insulated from knowing if polygons need left/right winding. If other cases come up
   beyond the "standard" winding, add more exported functions based on the case, e.g. getD3PolygonWinding(). */
export const getStandardPolygonWinding = (polygon) => _getPolygonWinding(polygon, STANDARD_IS_RIGHT_HAND);

export const unitTestPrivate = {
  _getPolygonWinding
};
